import { render, staticRenderFns } from "./textHeader.vue?vue&type=template&id=6e784b36&"
import script from "./textHeader.vue?vue&type=script&lang=js&"
export * from "./textHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports